import { ReactNode } from "react";
import { Link } from "react-router-dom";

interface Props {
  children: ReactNode;
  to: string;
}

const NavLink = (props: Props) => {
  return (
    <Link
      className="sm:px-4 hover:text-red-700 transition"
      to={props.to}
    >
      {props.children}
    </Link>
  );
};

export default NavLink;